module.exports = "data:image/webp;base64,UklGRrYAAABXRUJQVlA4WAoAAAAQAAAAOwAAHQAAQUxQSDEAAAABN0AmbRulX68xeXOziIgcR6GmkRSIxwMSkHISTgL+bWxLFdH/CTjUzdxAgv65oGXcAFZQOCBeAAAAkAQAnQEqPAAeAD5tMJNGpCMhoSwIAIANiWkAAFyehPIUpQnusKJFFM2O3yAAAP758IKuqPwKI/jOfpougUCKzB6sDSRWks+mVFVRvRdRKMw2SrJ07shulB6R9gAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/right-bar-bg.webp
// module id = FaPn
// module chunks = 3